import { SCHEDULE_INTERVIEW_COPY } from '../../../../config/schedule.copy';

export const copy = SCHEDULE_INTERVIEW_COPY.details;

export const INTERVIEW_TYPE_OPTIONS = [
  { value: 'one_on_one', label: 'One-on-one interview' },
  { value: 'panel', label: 'Panel interview' },
];

/** Shared condition that gates date/time edit fields behind the hidden
 *  `isDateTimeEditing` toggle field. `preserveValue` keeps field values
 *  when the row unmounts (e.g. user switches back to view mode). */
export const isDateTimeEditingCondition = {
  operator: 'equal' as const,
  field: 'isDateTimeEditing',
  value: 'edit',
  preserveValue: true,
};
